import firebase from 'firebase';
const firebaseConfig = {
    apiKey: "AIzaSyCrjn7K1RrHdBmeeWBKDv9I2y0iZ5UqwiE",
    authDomain: "mebleagmar-e472e.firebaseapp.com",
    databaseURL: "https://mebleagmar-e472e.firebaseio.com",
    projectId: "mebleagmar-e472e",
    storageBucket: "mebleagmar-e472e.appspot.com",
    messagingSenderId: "410084398464",
    appId: "1:410084398464:web:26a4ebaa4c1b606027dd65",
    measurementId: "G-N7KYLBX22C"
};


firebase.initializeApp(firebaseConfig);
export const db = firebase.firestore();
export const auth = firebase.auth();
export const storage = firebase.storage();
export default firebase;
